import React, { useEffect } from 'react'
import { useState, useRef } from 'react'
import { Range } from 'react-date-range'

// Components
import { Col, Form } from 'react-bootstrap'
import { RecurringSection, SubHeader } from '../../../pages/billing/header/add-ons/styles'
import { RadioButton } from '../radio-button'
import { useClick } from '../helpers'
import { CustomDateInput } from '../custom-date-input'

export const EndRecurrence = ({ setEndRecurrence }: any) => {
  // Ending Recurrence Section
  const [recurrenceEnd, setRecurrenceEnd] = useState('stop-never')
  const [endDate, setEndDate] = useState<Date | undefined>()
  const [interval, setInterval] = useState<any>(1)

  useEffect(() => {
    var endData: any = { recurrenceEnd: recurrenceEnd }
    if (recurrenceEnd === 'stop-after-date') {
      // Format as YYYY-MM-DD.
      endData['endDate'] = endDate?.toISOString().split('T')[0]
    } else if (recurrenceEnd === 'stop-after-interval') {
      endData['occurences'] = interval
    }
    setEndRecurrence(endData)
  }, [recurrenceEnd, endDate, interval])

  const handleDateChange = (newDate: Date | Range | null) => {
    if (newDate instanceof Date) {
      setEndDate(newDate)
    }
  }

  return (
    <Form.Group as={Col} xl="9">
      <SubHeader>End Recurrence</SubHeader>
      <RecurringSection>
        <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => setRecurrenceEnd('stop-never')}>
          <RadioButton
            name="recurrenceEndRadio"
            value="stop-never"
            checked={recurrenceEnd === 'stop-never'}
            onChange={(e: any) => setRecurrenceEnd(e.target.value)}
          />
          <div>
            <h4 style={{ fontSize: '1.2rem', margin: 0 }}>Never</h4>
            <p style={{ margin: 0 }}>Transaction will continue indefinitely</p>
          </div>
        </div>
        <div
          style={{ display: 'flex', alignItems: 'center', padding: '2em 0 0' }}
          onClick={() => setRecurrenceEnd('stop-after-date')}
        >
          <RadioButton
            name="recurrenceEndRadio"
            value="stop-after-date"
            checked={recurrenceEnd === 'stop-after-date'}
            onChange={(e: any) => setRecurrenceEnd(e.target.value)}
          />
          <div>
            <h4 style={{ fontSize: '1.2rem', margin: 0 }}>Stop After&nbsp;</h4>
            <p style={{ margin: 0 }}>Transactions will run until this date</p>
          </div>
          <div style={{ marginLeft: '1em' }}>
            <CustomDateInput
              value={endDate || null}
              onChange={handleDateChange}
              required={recurrenceEnd === 'stop-after-date'}
              placeholder="MM-DD-YYYY"
            />
          </div>
        </div>
        <div
          style={{ display: 'flex', alignItems: 'center', padding: '2em 0 0' }}
          onClick={() => setRecurrenceEnd('stop-after-interval')}
        >
          <RadioButton
            name="recurrenceEndRadio"
            value="stop-after-interval"
            checked={recurrenceEnd === 'stop-after-interval'}
            onChange={(e: any) => setRecurrenceEnd(e.target.value)}
          />
          <h4 style={{ fontSize: '1.2rem', margin: 0 }}>Stop After&nbsp;</h4>
          <Form.Control
            type="number"
            isInvalid={recurrenceEnd === 'stop-after-interval' && (!interval || interval < 1)}
            value={interval}
            onChange={(e) => setInterval(e.target.value)}
            style={{ width: 100, margin: '0 1em' }}
          />
          <h4 style={{ fontSize: '1.2rem', margin: 0 }}>&nbsp;intervals</h4>
        </div>
      </RecurringSection>
      <p style={{ paddingTop: '1em' }}>Transactions that recur and never end will need to be cancelled manually.</p>
    </Form.Group>
  )
}
